import PropTypes from 'prop-types';
import React from 'react';

import { Tooltip, Button } from '@agilemd/web-components';

const propTypes = {
  url: PropTypes.string.isRequired,
  art: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};
const defaultProps = {};

function Browser({ url, name, art }) {
  return (
    <Tooltip content={name}>
      <Button
        href={url}
        // @ts-ignore
        target="_blank"
        variant="transparent"
        spacing={{ x: 2 }}
      >
        <img src={art} alt={name} className="browser__image" />
      </Button>
    </Tooltip>
  );
}
Browser.propTypes = propTypes;
Browser.defaultProps = defaultProps;

export default Browser;
